(function () {

  'use strict';

  function pxSelectWorkstationForDriverConfig($filter, $timeout, WorkstationListService) {
    return {
      restrict: 'EA',
      scope: {
        os: '=os',
        type: '=type',
        onlyUploadConfiguration: '=onlyUploadConfiguration',
        paginationObject: '=paginationObject',
        callback: '&callback'
      },
      templateUrl: 'app/components/printQueueProperties/driverConfig/selectWorkstationForDriverConfig/selectWorkstationForDriverConfig.template.html',
      link: function (scope) {

        scope.searchString = '';

        (function () {
          getFirstPage();
        })();

        function getFirstPage() {
          scope.list = [];
          scope.loadingPage = true;
          WorkstationListService.getWorkstationListPaged(scope.paginationObject)
            .then(function (workstations) {
              window.scrollTo(0, 0);
              scope.totalPages = workstations.page.totalPages;
              if (workstations.list) {
                scope.list = checkForUsers(workstations.list);
              }
              scope.loadingPage = false;
            })
            .catch(function () {
              scope.loadingPage = false;
            });
        }

        scope.textSearch = function () {
          scope.list = [];
          scope.paginationObject.pagingCriteria.match = scope.searchString || undefined;
          getFirstPage();
        };

        function getNextPage() {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.paginationObject.pagingCriteria.page += 1;
            scope.loadingPage = true;
            WorkstationListService.getWorkstationListPaged(scope.paginationObject)
              .then(function (pagedWorkstations) {
                if (pagedWorkstations.list) {
                  scope.list = scope.list.concat(checkForUsers(pagedWorkstations.list));
                }
                scope.loadingPage = false;
              })
              .catch(function () {
                scope.loadingPage = false;
              });
          }
        }

        function checkForUsers(workstations) {
          const users = $filter('translate')('Users');
          const user = $filter('translate')('USER');
          const message = $filter('translate')('YouAndOnlyYouMustBeSignedInToTheComputer');
          workstations.forEach(workstation => {
            if (workstation.info.userIds.length > 1 && !scope.onlyUploadConfiguration) {
              workstation.info.selectDisabled = true;
              workstation.info.warning = message;
              workstation.info.dimmed = true;
              workstation.info.name += ' (' + users + ': ' + workstation.info.userIds.length + ')';
            } else if (workstation.info.userIds.length > 1 && scope.onlyUploadConfiguration) {
              workstation.info.name += ' (' + users + ': ' + workstation.info.userIds.length + ')';
            } else {
              workstation.info.name += ' (' + user + ': 1)';
            }
          });
          return workstations;
        }

        let scrollEnd = null;
        let containerHeight = null;
        angular.element('.pagination-small-results').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function () {
                getNextPage();
              }, 300);
            }
          }
        });

        scope.$on('$destroy', function () {
          angular.element('.pagination-small-results').off('scroll');
        });

        scope.selectItem = function (event, selectedItem) {
          event.stopPropagation();
          scope.callback({ selectedItem });
        };

        scope.closePopup = function (event) {
          scope.callback({ selectItem: null });
        };

        // TOOLTIP STUFF

        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          const offsetLeft = angular.element('.context-content-container')[0].offsetLeft;
          const offsetTop = angular.element('.context-content-container')[0].offsetTop;
          if (showTip) {
            position.startX = position.startX - offsetLeft;
            position.startY = position.startY - offsetTop;
            switch (tooltipScope) {
              case 'gatewayDetails':
                gatewayTooltip(position, context);
                break;
            }
          } else {
            scope.clearTooltip();
          }
        };

        function gatewayTooltip(position, context) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'Gateways',
            type: 'gatewayDetails',
            icon: null,
            workstation: context
          };
          scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 20 },
            contextMenu: true
          };
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        };

      }
    };
  }

  pxSelectWorkstationForDriverConfig.$inject = ['$filter', '$timeout', 'WorkstationListService'];

  angular
    .module('printix-admin')
    .directive('pxSelectWorkstationForDriverConfig', pxSelectWorkstationForDriverConfig);

})();
